/* 正式な書類 (/lp/documents/*) を行き先にした、フッターの法的リンク */
export const LP_LEGAL_LINKS = [
  { label: "特定商取引法に基づく表記", href: "/lp/documents/tokushoho" },
  { label: "利用規約", href: "/lp/documents/terms" },
  { label: "プライバシーポリシー", href: "/lp/documents/privacy" },
];
